import Vue from 'vue';

import Home from '@/views/Home/Home.vue';
import Modal from '@/components/Modal/Modal.vue';

import Scrollbar from 'smooth-scrollbar';
import ICountUp from 'vue-countup-v2';
import MarqueeText from 'vue-marquee-text-component';
import Vue2TouchEvents from 'vue2-touch-events';
import VueInputMask from "vue-inputmask"



Vue.component('marquee-text', MarqueeText);
Vue.use(VueInputMask.default);
Vue.use(Vue2TouchEvents);

export default {
  name: 'bridge',
  components: {
    Home,
    Modal,
    MarqueeText,
    ICountUp,
  },
  data: () => {
    return { }
  },
  methods: { },
  created() { },
  mounted(){
    Scrollbar.init(document.querySelector('.home'));
  }
}